import { render } from "./EPurchaser.vue?vue&type=template&id=5a64ae1c"
import script from "./EPurchaser.vue?vue&type=script&lang=js"
export * from "./EPurchaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__